export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_fragment_3.6dbb6d01.jpg";